import React from 'react'
import './Home.sass'
import Hero from '../../components/Hero/Hero'
import About from '../../components/About/About'
import RequestConsultation from '../../components/RequestConsultation/RequestConsultation'
import FeedsCarousel from '../../components/FeedsCarousel/FeedsCarousel'
import WhatULearn from '../../components/WhatULearn/WhatULearn'
import Style from '../../components/Style/Style'

function Home() {
  return (
    <div className="Home">
      <Hero />
      <Style />
      <RequestConsultation />
      <About />
      <WhatULearn />
      <FeedsCarousel />
    </div>
  )
}

export default Home
